import React from "react"

import { useContrastTexts } from "../../hooks/useContrastText"

import { Input } from "./Inputs"
import Typography from "./Typography"

const SmartColorInput = ({
  label,
  value,
  onChange,
  className = "",
  showTextPreview = true,
  fallbackColors = {
    primaryFallback: "#000000",
    secondaryFallback: "#6B7280",
    mutedFallback: "#9CA3AF"
  }
}) => {
  // Get smart text colors based on background
  const textColors = useContrastTexts(value || "#ffffff", fallbackColors)

  return (
    <div className={`space-y-1 ${className}`}>
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <div className="flex gap-2">
        <input
          type="color"
          value={value || "#ffffff"}
          onChange={(e) => onChange(e.target.value)}
          className="h-8 w-12 cursor-pointer rounded border border-gray-light"
        />
        <Input
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#ffffff"
          className="flex-1"
        />
      </div>

      {/* Text Color Preview */}
      {showTextPreview && (
        <div className="mt-2 rounded border border-gray-200 bg-gray-50 p-3">
          <Typography variant="small" className="mb-2 font-medium text-gray-600">
            Text colors will be:
          </Typography>
          <div className="flex items-center gap-4 text-sm">
            <div className="flex items-center gap-2">
              <div className="h-4 w-4 rounded border border-gray-300" style={{ backgroundColor: textColors.primary }} />
              <span style={{ color: textColors.primary }}>Primary text</span>
            </div>
            <div className="flex items-center gap-2">
              <div
                className="h-4 w-4 rounded border border-gray-300"
                style={{ backgroundColor: textColors.secondary }}
              />
              <span style={{ color: textColors.secondary }}>Secondary text</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="h-4 w-4 rounded border border-gray-300" style={{ backgroundColor: textColors.muted }} />
              <span style={{ color: textColors.muted }}>Muted text</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default SmartColorInput
